import { z } from 'src/lib';
import { OperacionNOTESFields } from './fields';
import { schemaEntityWithId } from 'src/types';

export const schemaOperacionNOTES = z
    .object({
        [OperacionNOTESFields.CodPais]: z.number(),
        [OperacionNOTESFields.NombrePais]: z.string(),
        [OperacionNOTESFields.CodUnidadNegocio]: z.number(),
        [OperacionNOTESFields.UnidadNegocio]: z.string(),
        [OperacionNOTESFields.CodSectorComercial]: z.number(),
        [OperacionNOTESFields.SectorComercial]: z.string(),
        [OperacionNOTESFields.FechaSolicitud]: z.coerce.date(),
        [OperacionNOTESFields.FechaVencimiento]: z.coerce.date(),
        [OperacionNOTESFields.CodEstado]: z.number(),
        [OperacionNOTESFields.DescEstado]: z.string(),
        [OperacionNOTESFields.FechaAprobacion]: z.coerce.date(),
        [OperacionNOTESFields.FechaAlta]: z.coerce.date(),
        [OperacionNOTESFields.IdUsuarioAlta]: z.number(),
        [OperacionNOTESFields.NombreUsuarioAlta]: z.string(),
        [OperacionNOTESFields.ApellidoUsuarioAlta]: z.string(),
        [OperacionNOTESFields.MailUsuarioAlta]: z.string(),
        
        [OperacionNOTESFields.TipoNota]: z.string(),
        [OperacionNOTESFields.Cliente]: z.string(),
        [OperacionNOTESFields.CapitalASuscribir]: z.string(),
        [OperacionNOTESFields.Moneda]: z.string(),
        [OperacionNOTESFields.Vencimiento]: z.coerce.date(),
        [OperacionNOTESFields.FechaEmision]: z.coerce.date(),
        [OperacionNOTESFields.Emisor]: z.string(),
        [OperacionNOTESFields.Subyacentes]: z.string(),
        [OperacionNOTESFields.ObsSubyacentes]: z.string(),
        [OperacionNOTESFields.Cupon]: z.string(),
        [OperacionNOTESFields.FrecuenciaPago]: z.string(),
        [OperacionNOTESFields.CondicionPago]: z.string(),
        [OperacionNOTESFields.ObsCupon]: z.string(),
        [OperacionNOTESFields.Participacion]: z.string(),
        [OperacionNOTESFields.FormaParticipacion]: z.string(),
        [OperacionNOTESFields.DescripcionParticipacion]: z.string(),
        [OperacionNOTESFields.ObsParticipacion]: z.string(),
        [OperacionNOTESFields.TipoProteccion]: z.string(),
        [OperacionNOTESFields.NivelProteccion]: z.string(),
        [OperacionNOTESFields.DescripcionProteccion]: z.string(),
        [OperacionNOTESFields.ObsProteccion]: z.string(),
        [OperacionNOTESFields.BarreraRescateAnticipado]: z.string(),
        [OperacionNOTESFields.CondicionRescateAnticipado]: z.string(),
        [OperacionNOTESFields.FrecuenciaObservacion]: z.string(),
        [OperacionNOTESFields.ObsRescateAnticipado]: z.string(),
        [OperacionNOTESFields.ArchivoGrafico]: z.string().nullable(),

        [OperacionNOTESFields.EstadoFinalizado]: z.boolean(),
        [OperacionNOTESFields.PermiteEditarOperacion]: z.boolean(),
        [OperacionNOTESFields.PermiteEliminarOperacion]: z.boolean(),
        [OperacionNOTESFields.IdMensaje]: z.number()
    })
    .merge(schemaEntityWithId);

export type OperacionNOTES = z.infer<typeof schemaOperacionNOTES>;